<script>
import { EventBus } from '@/helpers/eventBus'
import { validationStatus } from '@/enums/validationStatus'
import alertDialogItemsJson from '@/data/json/upload/alertDialogItem.json'
import {createCancelToken} from "@/helpers/api";
export default {
  props: {
    selected: { type: Array },
    order: {type: Object}
  },
  data: () => ({
    dialogTranslations: alertDialogItemsJson.data,
    allowedFileTypes: ['application/pdf'],
    isAddingAttachments: false,
    showError: false,
    errorMsg: '',
    filteredFiles: [],
    filesInTransfer: {
      inTransfer: false,
      percentage: 0
    },
    uploadCancelToken: null
  }),
  methods: {
    //#region Attachments
    addAttachments() {
      this.filteredFiles = []
      if (this.selected.length > 0) {
        if (
          this.selected.find(
            selected => selected.validationStatus !== validationStatus.success
          )
        ) {
          this.showError = true
          this.errorMsg = this.$t('component.common.attachmentsUploader.error.invalid.document.status' )
          return
        }
        // open FilePicker-Dialog
        this.$refs.attachmentUploader.click()
      }
    },
    async onAttachmentsSelected(e) {
      // check if filetype match
      for (var i = 0; i < e.target.files.length; i++) {
        const file = e.target.files[i]
        if (!this.checkFileType(file.type)) {
          this.showError = true
          this.errorMsg = this.$t('component.common.attachmentsUploader.error.filetype.mismatch')
          this.$refs.attachmentUploader.value = null
          return
        } else {
          // all fine, add file to array
          this.filteredFiles.push(file)
        }
      }
      this.isAddingAttachments = true
      // upload Files
      this.uploadFiles()
    },
    //#endregion Attachments
    async uploadFiles() {
      const files = this.filteredFiles
      const formData = new FormData()
      const attachmentUploader = this.$refs.attachmentUploader
      // show upload status overlay
      this.filesInTransfer.inTransfer = true
      // recieve upload-percentage from upload-service
      EventBus.$on('uploadPercentage', percentage => {
        this.filesInTransfer.percentage = percentage
      })
      // append files to formData
      files.forEach(file => {
        formData.append('file', file)
      })
      // append selected DocumentIds to formData
      this.selected.forEach(selectedItem => {
        formData.append('DocumentIds', selectedItem.documentId)
      })
      // create upload-cancelation-token
      this.uploadCancelToken = createCancelToken()
      // add current order Id to formData
      formData.append('OrderId', this.order.orderId)
      // upload attachments
      return await this.$uploadService
        .addAttachments(formData, this.uploadCancelToken)
        .then((response) => {
          if (Object.prototype.hasOwnProperty.call(response, 'validationCode') && response.validationCode > 200) {
            const code = Object.entries(this.$enums.validationCode).find(([, value]) => value === response.validationCode);
            const key = this.dialogTranslations.find(item => item.name === code[0]);
            this.showError = true;
            this.errorMsg = this.$cms.get(this.dialogTranslations, key?.name);
            return;
          }
          this.$emit('uploaded')
        })
        .catch((e) => {
          console.error('error:', e)
        })
        .finally(() => {
          // reset all values
          attachmentUploader.value = ''
          EventBus.$off('uploadPercentage')
          this.filteredFiles = []
          this.filesInTransfer.inTransfer = false
          this.filesInTransfer.percentage = 0
          this.isAddingAttachments = false
        })
    },
    cancelUpload() {
      this.$uploadService.cancelUpload(this.uploadCancelToken)
    },
    checkFileType(fileType) {
      if (this.allowedFileTypes.indexOf(fileType) >= 0) {
        return true
      }
      return false
    }
  }
}
</script>
<template>
  <div>
    <v-overlay :value="filesInTransfer.inTransfer">
      <v-card max-width="400" light>
        <v-card-text class="text-center">
          <v-progress-linear
            indeterminate
            color="primary"
            class="mb-3">
          </v-progress-linear>
          <span>
            {{ $t('component.common.attachmentsUploader.data.loading') }}<br />
            {{ $t('global.patience.please') }}
          </span>
          <br />
        </v-card-text>
        <v-card-text class="text-center">
          <v-progress-circular
            :rotate="90"
            :size="100"
            :width="15"
            :value="filesInTransfer.percentage"
            color="primary">
            {{ filesInTransfer.percentage }}%
          </v-progress-circular>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="justify-center">
          <div class="text-xs-center">
            <v-btn @click="cancelUpload()">{{
                $t('button.cancel')
              }}</v-btn>
          </div>
        </v-card-actions>
      </v-card>
    </v-overlay>
    <v-dialog v-model="showError" :max-width="500">
      <v-card>
        <DialogBaseColoredTitle color="error">{{
            $t('global.the.error') }}</DialogBaseColoredTitle>
        <v-divider></v-divider>
        <DialogBaseText class="text-center primary--text">
          <v-row>
            <v-col>{{ errorMsg }}</v-col>
          </v-row>
          <v-divider></v-divider>
        </DialogBaseText>
        <DialogBaseActions>
          <v-btn
            class="text-center px-8"
            color="primary"
            @click="showError = false">
            {{ $t('button.close') }}</v-btn>
        </DialogBaseActions>
      </v-card>
    </v-dialog>
    <v-tooltip content-class="dark_tip" top>
      <template #activator="{ on }">
        <v-btn
          id="upload_validation_add_attachment_to_selected_documents"
          :disabled="selected.length <= 0"
          :loading="isAddingAttachments"
          icon
          outlined
          color="success"
          v-on="on"
          @click="addAttachments()">
          <v-icon color="success">mdi-paperclip</v-icon>
        </v-btn>
        <input
          id="upload_validation_attachments"
          ref="attachmentUploader"
          class="d-none"
          type="file"
          :accept="allowedFileTypes"
          multiple
          @change="onAttachmentsSelected"/>
      </template>
      <span>{{ $t('component.common.attachmentsUploader.tooltip.attachment.icon') }}</span>
    </v-tooltip>
  </div>
</template>
